import React, { useState, useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { Link } from 'react-router-dom';
import aarohanLogo from '../assets/images/logo.png';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [done, setDone] = useState(false);
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: '-50px' });

  return (
    <>
      {/* Newsletter */}
      <div style={{ background: '#FAF6EF', borderTop: '1px solid rgba(184,134,11,0.12)', padding: '68px 6%' }}>
        <div className="max-w" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 32 }}>
          <div>
            <h3 style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 28, fontWeight: 500, color: '#1A1209', marginBottom: 8, letterSpacing: '-0.5px' }}>Stay in the loop</h3>
            <p style={{ fontSize: 15, color: '#7A6E5E', fontWeight: 300, fontFamily: "'DM Sans',sans-serif" }}>Batch openings, AI features, artist stories — in your inbox.</p>
          </div>
          {done ? (
            <motion.p initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} style={{ color: '#C8922A', fontFamily: "'DM Sans',sans-serif", fontSize: 15, fontWeight: 500 }}>✓ You're subscribed!</motion.p>
          ) : (
            <form onSubmit={e => { e.preventDefault(); if (email) setDone(true); }} style={{ display: 'flex' }}>
              <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="your@email.com"
                style={{
                  padding: '14px 24px', border: '1px solid rgba(200,146,42,0.3)', borderRight: 'none',
                  borderRadius: '2px 0 0 2px', fontFamily: "'DM Sans',sans-serif", fontSize: 14,
                  background: '#FAF7F0', color: '#1A1209', outline: 'none', width: 280,
                  transition: 'border-color 0.3s'
                }}
                onFocus={(e) => e.target.style.borderColor = '#C8922A'}
                onBlur={(e) => e.target.style.borderColor = 'rgba(200,146,42,0.3)'}
              />
              <button type="submit" className="btn-liquid" style={{ borderRadius: '0 2px 2px 0', padding: '14px 28px', fontSize: 11, letterSpacing: '2px' }}>Subscribe</button>
            </form>
          )}
        </div>
      </div>

      {/* Main footer */}
      <footer style={{ background: '#100C06', padding: '80px 6% 40px', position: 'relative', overflow: 'hidden' }} ref={ref}>
        {/* Animated EQ background spanning width */}
        <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, display: 'flex', gap: 6, alignItems: 'flex-end', opacity: 0.04, justifyContent: 'space-between', padding: '0 2%' }}>
          {Array.from({ length: 48 }, (_, i) => (
            <div key={i} className="wave-bar"
              style={{
                width: 8, height: `${30 + Math.sin(i * 0.4) * 20 + Math.random() * 20}px`,
                background: '#C8922A', borderRadius: 4,
                '--dur': `${0.8 + (i % 6) * 0.2}s`, animationDelay: `${i * 0.05}s`
              }} />
          ))}
        </div>

        <div className="max-w" style={{ position: 'relative', zIndex: 10 }}>
          <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 1fr 1fr', gap: 48, marginBottom: 80 }}>
            <div>
              <Link to="/" style={{ textDecoration: 'none', display: 'flex', alignItems: 'center', gap: 14, marginBottom: 20 }}>
                <img
                  src={aarohanLogo}
                  alt="Aarohan Studio"
                  style={{
                    height: 52,
                    width: 'auto',
                    objectFit: 'contain',
                    filter: 'drop-shadow(0 0 12px rgba(200,146,42,0.25))',
                  }}
                />
                <span style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 26, color: '#FAF7F0', letterSpacing: '5px' }}>
                  A<span style={{ color: '#C8922A' }}>A</span>ROHAN
                </span>
              </Link>
              <p style={{ fontSize: 14, color: 'rgba(250,247,240,0.45)', lineHeight: 1.85, fontWeight: 300, maxWidth: 260, fontFamily: "'DM Sans',sans-serif" }}>
                Where sound becomes art. Professional recording studio & music institute — Indore, Madhya Pradesh.
              </p>
              <div style={{ display: 'flex', gap: 14, marginTop: 24 }}>
                {[
                  {
                    label: 'Instagram',
                    href: 'https://instagram.aarohanstudio.in',
                    icon: (
                      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="2" y="2" width="20" height="20" rx="5.5" stroke="currentColor" strokeWidth="1.7" fill="none" />
                        <circle cx="12" cy="12" r="4.5" stroke="currentColor" strokeWidth="1.7" fill="none" />
                        <circle cx="17.5" cy="6.5" r="1.1" fill="currentColor" />
                      </svg>
                    ),
                  },
                  {
                    label: 'Facebook',
                    href: 'https://facebook.aarohanstudio.in',
                    icon: (
                      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M17 2h-3a5 5 0 0 0-5 5v3H6v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3V2z" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" fill="none" />
                      </svg>
                    ),
                  },
                  {
                    label: 'YouTube',
                    href: 'https://youtube.aarohanstudio.in',
                    icon: (
                      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="2" y="5" width="20" height="14" rx="4" stroke="currentColor" strokeWidth="1.7" fill="none" />
                        <polygon points="10,9 16,12 10,15" fill="currentColor" />
                      </svg>
                    ),
                  },
                ].map(({ label, href, icon }) => (
                  <a
                    key={label}
                    href={href}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={label}
                    style={{
                      width: 46,
                      height: 46,
                      border: '1px solid rgba(250,247,240,0.1)',
                      borderRadius: 2,
                      color: 'rgba(250,247,240,0.45)',
                      background: 'none',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      textDecoration: 'none',
                      transition: 'all 0.3s cubic-bezier(0.22,1,0.36,1)',
                      flexShrink: 0,
                    }}
                    onMouseEnter={e => {
                      e.currentTarget.style.borderColor = '#C8922A';
                      e.currentTarget.style.color = '#C8922A';
                      e.currentTarget.style.transform = 'translateY(-3px)';
                      e.currentTarget.style.background = 'rgba(200,146,42,0.07)';
                    }}
                    onMouseLeave={e => {
                      e.currentTarget.style.borderColor = 'rgba(250,247,240,0.1)';
                      e.currentTarget.style.color = 'rgba(250,247,240,0.45)';
                      e.currentTarget.style.transform = 'translateY(0)';
                      e.currentTarget.style.background = 'none';
                    }}
                  >
                    {icon}
                  </a>
                ))}
              </div>
            </div>

            {[
              { title: 'Studio', links: ['Gear & Equipment', 'Session Musicians', 'Mastering'] },
              { title: 'Institute', links: ['Online Classes', 'Offline Batches', 'AI Features'] },
              { title: 'Company', links: ['About Us', 'Privacy Policy', 'Terms of Use', 'Careers'] },
            ].map(({ title, links }) => (
              <div key={title}>
                <h4 style={{ fontSize: 9, letterSpacing: '3px', textTransform: 'uppercase', color: 'rgba(250,247,240,0.25)', marginBottom: 24, fontFamily: "'DM Sans',sans-serif", fontWeight: 600 }}>{title}</h4>
                {links.map(l => (
                  <a key={l} style={{ display: 'block', fontSize: 14, color: 'rgba(250,247,240,0.4)', marginBottom: 12, fontFamily: "'DM Sans',sans-serif", fontWeight: 300, textDecoration: 'none', transition: 'color 0.2s' }}
                    onMouseEnter={e => e.target.style.color = '#C8922A'}
                    onMouseLeave={e => e.target.style.color = 'rgba(250,247,240,0.4)'}
                  >{l}</a>
                ))}
              </div>
            ))}
          </div>

          <div style={{ borderTop: '1px solid rgba(250,247,240,0.08)', paddingTop: 32, display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 16 }}>
            <p style={{ fontSize: 12, color: 'rgba(250,247,240,0.3)', fontFamily: "'DM Sans',sans-serif", fontWeight: 300 }}>© {new Date().getFullYear()} AAROHAN. All rights reserved. Indore, MP.</p>
            <div style={{ display: 'flex', gap: 32 }}>
              {['Privacy', 'Terms', 'Refunds'].map(l => (
                <a key={l} style={{ fontSize: 12, color: 'rgba(250,247,240,0.3)', fontFamily: "'DM Sans',sans-serif", textDecoration: 'none', transition: 'color 0.2s' }}
                  onMouseEnter={e => e.target.style.color = '#C8922A'}
                  onMouseLeave={e => e.target.style.color = 'rgba(250,247,240,0.3)'}
                >{l}</a>
              ))}
            </div>
          </div>
        </div>

        {/* Oversized AAROHAN — background watermark like Hindi ghost text */}
        <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, overflow: 'hidden', pointerEvents: 'none', textAlign: 'center', zIndex: 0 }}>
          <motion.h1
            initial={{ opacity: 0, y: 60, scale: 0.95 }}
            animate={inView ? { opacity: 0.03, y: 0, scale: 1 } : { opacity: 0 }}
            transition={{ duration: 1.2, ease: [0.22, 1, 0.36, 1] }}
            style={{
              fontFamily: "'Cormorant Garamond',serif",
              fontSize: 'clamp(80px,14vw,240px)',
              fontWeight: 700,
              color: '#C8922A',
              letterSpacing: '-4px',
              lineHeight: 1,
              userSelect: 'none',
              whiteSpace: 'nowrap',
              margin: 0,
            }}
          >
            AAROHAN
          </motion.h1>
        </div>
      </footer>
    </>
  );
}
